const MVV = [
  { title: "Missão", text: "Transformar espera em movimento: colocar o crédito certo nas mãos de quem tem pressa de conquistar, com clareza em cada número e acompanhamento em cada passo." },
  { title: "Visão", text: "Um Brasil em que ninguém adia uma conquista importante por falta de caminho. Ser a referência nacional em cartas contempladas, reconhecida pela confiança de quem compra, vende e é parceiro." },
];

const VALORES = [
  ["Clareza", "informação simples, número na mesa, sem letra miúda."],
  ["Agilidade", "decisão importante não espera na fila."],
  ["Confiança", "cada negociação conduzida como se fosse a nossa."],
  ["Curadoria", "estoque selecionado, menos ruído e mais oportunidade."],
  ["Compromisso", "acompanhamos do primeiro contato à transferência concluída."],
  ["Parceria", "crescemos junto com clientes e representantes."],
];

const Card = ({ title, children, testId, className = "" }) => (
  <div className={`rounded-[24px] border border-[#C8D7E4] bg-[#F7F5F0] p-7 ${className}`} data-testid={testId}>
    <h3 className="text-sm font-bold uppercase tracking-[0.2em] text-[#196ABC]">{title}</h3>
    <div className="mt-3 text-base leading-relaxed text-[#15579A]/80">{children}</div>
  </div>
);

export const About = () => (
  <section id="quem-somos" className="scroll-mt-20 bg-white py-24 sm:py-32" data-testid="about-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid gap-12 lg:grid-cols-2 lg:gap-20">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#218FFF]">Quem somos</p>
          <h2 className="mt-3 text-3xl font-extrabold uppercase tracking-tight text-[#15579A] sm:text-4xl">Curadoria, clareza e acompanhamento.</h2>
          <blockquote className="mt-10 border-l-4 border-[#218FFF] pl-6 font-serif text-3xl italic leading-snug text-[#196ABC]"
            data-testid="about-quote">
            “Conquistas importantes merecem clareza.”
          </blockquote>
        </div>
        <div className="space-y-5 text-base leading-relaxed text-[#15579A]/85" data-testid="about-text">
          <p>O consórcio é um dos caminhos mais sólidos para conquistar um imóvel ou um veículo. Mas esperar a contemplação nem sempre combina com o momento da vida de quem precisa decidir.</p>
          <p>O Clube do Contemplado nasceu para resolver exatamente isso: conectar pessoas a créditos de consórcio já contemplados, com curadoria, clareza e acompanhamento em cada etapa, para que decisões importantes avancem sem depender da espera tradicional.</p>
          <p>Estamos em São Paulo e trabalhamos com cartas de diversas administradoras, para imóveis e veículos. Nossa equipe comercial acompanha a negociação do primeiro contato até a transferência da cota.</p>
        </div>
      </div>
      <div className="mt-16 grid gap-5 lg:grid-cols-3">
        {MVV.map((m) => <Card key={m.title} title={m.title} testId={`about-${m.title.toLowerCase()}`}><p>{m.text}</p></Card>)}
        <Card title="Valores" testId="about-valores">
          <ul className="space-y-2 text-sm">
            {VALORES.map(([v, t]) => <li key={v}><strong className="text-[#15579A]">{v}:</strong> {t}</li>)}
          </ul>
        </Card>
      </div>
    </div>
  </section>
);
